import React from 'react'
import '../TemplateMessage/GenericTemplate/TemplateMessage.css'
import { LocationIcon } from '../../../icons/Icons'

class GeoReply extends React.Component {
  setPosition = geolocation => {
    const message = {
      // type: 'message',
      // text: 'Geo Position',
      // entities: [{
      //     geo: {
      //         elevation: 0,
      //         type: "GeoCoordinates",
      //         name: "myPlace",
      //         latitude: geolocation.coords.latitude,
      //         longitude: geolocation.coords.longitude
      //     },
      //     type: 'Place'
      // }]
      type: 'location',
      title: 'Geo Position',
      payload: {
        coordinates: {
          lat: geolocation.coords.latitude,
          long: geolocation.coords.longitude,
        },
      },
    }
    this.props.postMessage(message)
  }

  handlerError = error => console.log(error)

  render() {
    return (
      <div
        className="quick_reply"
        onClick={() =>
          navigator.geolocation.getCurrentPosition(
            this.setPosition,
            this.handlerError,
          )
        }>
        <LocationIcon />
        <span>Send Location</span>
      </div>
    )
  }
}

export default GeoReply
